
export const HIDE_NO_SESSION_LISTINGS=false


// Amenity options for "What's included" (trainer input + listing display)
// NOTE: These are static for now. Icons can be replaced/updated later in `IconCollection.js`
// by matching the `iconName` values below.
export const AMENITY_OPTIONS = [
  // Formation et contenu
  {
    label: 'Certificat',
    value: 'certificate',
    iconName: 'amenity-certificate',
    category: 'Formation et contenu',
  },
  {
    label: 'Session de Q&R',
    value: 'qa_session',
    iconName: 'amenity-qa-session',
    category: 'Formation et contenu',
  },
  {
    label: 'Coaching',
    value: 'coaching',
    iconName: 'amenity-coaching',
    category: 'Formation et contenu',
  },
  {
    label: 'Groupe privé',
    value: 'private_group',
    iconName: 'amenity-private-group',
    category: 'Formation et contenu',
  },
  {
    label: 'Accès à vie',
    value: 'lifetime_access',
    iconName: 'amenity-lifetime-access',
    category: 'Formation et contenu',
  },
  {
    label: 'Accès aux replays',
    value: 'replay_access',
    iconName: 'amenity-replay-access',
    category: 'Formation et contenu',
  },
  {
    label: 'Certificat de participation',
    value: 'certificate_participation',
    iconName: 'amenity-certificate-participation',
    category: 'Formation et contenu',
  },
  {
    label: 'Commentaires personnalisés',
    value: 'personalized_feedback',
    iconName: 'amenity-personalized-feedback',
    category: 'Formation et contenu',
  },
  {
    label: 'Évaluation / Suivi des progrès',
    value: 'evaluation_progress_tracking',
    iconName: 'amenity-progress-tracking',
    category: 'Formation et contenu',
  },
  {
    label: 'Matériel de cours',
    value: 'course_materials',
    iconName: 'amenity-course-material',
    category: 'Formation et contenu',
  },

  // Confort et restauration
  {
    label: 'Déjeuner inclus',
    value: 'lunch_included',
    iconName: 'amenity-lunch',
    category: 'Confort et restauration',
  },
  { label: 'Boissons', value: 'drinks', iconName: 'amenity-drinks', category: 'Confort et restauration' },
  {
    label: 'Pause café',
    value: 'coffee_break',
    iconName: 'amenity-coffee-break',
    category: 'Confort et restauration',
  },
  { label: 'En-cas', value: 'snacks', iconName: 'amenity-snacks', category: 'Confort et restauration' },
  {
    label: 'Relaxation',
    value: 'relaxation',
    iconName: 'amenity-relaxation',
    category: 'Confort et restauration',
  },

  // Organisation
  {
    label: 'Petit groupe',
    value: 'small_group',
    iconName: 'amenity-small-group',
    category: 'Organisation',
  },
  {
    label: 'Places limitées',
    value: 'limited_seats',
    iconName: 'amenity-limited-seats',
    category: 'Organisation',
  },
  {
    label: 'Formation intensive',
    value: 'intensive_training',
    iconName: 'amenity-intensive-training',
    category: 'Organisation',
  },
  {
    label: 'Formation sur plusieurs jours',
    value: 'multi_day_training',
    iconName: 'amenity-multi-day',
    category: 'Organisation',
  },
  {
    label: 'Horaire fixe',
    value: 'fixed_schedule',
    iconName: 'amenity-fixed-schedule',
    category: 'Organisation',
  },
  {
    label: 'Session programmée',
    value: 'scheduled_session',
    iconName: 'amenity-scheduled-session',
    category: 'Organisation',
  },

  // Pratique et matériel
  {
    label: 'Kit inclus',
    value: 'kit_included',
    iconName: 'amenity-kit-included',
    category: 'Pratique et matériel',
  },
  {
    label: 'Accès au studio',
    value: 'studio_access',
    iconName: 'amenity-studio-access',
    category: 'Pratique et matériel',
  },
  {
    label: 'Accès au logiciel',
    value: 'software_access',
    iconName: 'amenity-software-access',
    category: 'Pratique et matériel',
  },
  {
    label: 'Pratique sur modèle',
    value: 'practice_model',
    iconName: 'amenity-practice-model',
    category: 'Pratique et matériel',
  },
  {
    label: 'Équipement fourni',
    value: 'equipment_provided',
    iconName: 'amenity-equipment-provided',
    category: 'Pratique et matériel',
  },
  {
    label: 'Produit fourni',
    value: 'product_provided',
    iconName: 'amenity-product-provided',
    category: 'Pratique et matériel',
  },
  {
    label: 'Exercices pratiques',
    value: 'practical_exercises',
    iconName: 'amenity-practical-exercises',
    category: 'Pratique et matériel',
  },
  {
    label: 'Démonstration en direct',
    value: 'live_demonstration',
    iconName: 'amenity-live-demonstration',
    category: 'Pratique et matériel',
  },
  {
    label: 'Scénarios de pratique réelle',
    value: 'real_life_practice',
    iconName: 'amenity-real-life-practice',
    category: 'Pratique et matériel',
  },

  // Bonus et ressources
  {
    label: 'Modèles fournis',
    value: 'templates_provided',
    iconName: 'amenity-templates',
    category: 'Bonus et ressources',
  },
  {
    label: 'Listes de contrôle',
    value: 'checklists',
    iconName: 'amenity-checklists',
    category: 'Bonus et ressources',
  },
  {
    label: 'Ressources supplémentaires',
    value: 'additional_resources',
    iconName: 'amenity-additional-resources',
    category: 'Bonus et ressources',
  },
  {
    label: 'Bonus exclusifs',
    value: 'exclusive_bonuses',
    iconName: 'amenity-exclusive-bonuses',
    category: 'Bonus et ressources',
  },
  {
    label: 'Accès aux outils',
    value: 'access_tools',
    iconName: 'amenity-access-tools',
    category: 'Bonus et ressources',
  },

  // Emplacement et accessibilité
  {
    label: 'Parking',
    value: 'parking',
    iconName: 'amenity-parking',
    category: 'Emplacement et accessibilité',
  },
  { label: 'Wi-Fi', value: 'wifi', iconName: 'amenity-wifi', category: 'Emplacement et accessibilité' },
  {
    label: 'Toilettes',
    value: 'restrooms',
    iconName: 'amenity-restrooms',
    category: 'Emplacement et accessibilité',
  },
  {
    label: 'Climatisation',
    value: 'air_conditioning',
    iconName: 'amenity-air-conditioning',
    category: 'Emplacement et accessibilité',
  },
  {
    label: 'Accès handicapé',
    value: 'disabled_access',
    iconName: 'amenity-disabled-access',
    category: 'Emplacement et accessibilité',
  },
  {
    label: 'Salle entièrement équipée',
    value: 'fully_equipped_room',
    iconName: 'amenity-fully-equipped',
    category: 'Emplacement et accessibilité',
  },
  {
    label: 'Accès transports en commun',
    value: 'public_transport',
    iconName: 'amenity-public-transport',
    category: 'Emplacement et accessibilité',
  },
  {
    label: 'Lieu professionnel',
    value: 'professional_venue',
    iconName: 'amenity-professional-venue',
    category: 'Emplacement et accessibilité',
  },

  // Affaires et opportunités
  {
    label: 'Conseils aux entreprises',
    value: 'business_advice',
    iconName: 'amenity-business-advice',
    category: 'Affaires et opportunités',
  },
  {
    label: 'Aide au lancement',
    value: 'launch_support',
    iconName: 'amenity-launch-support',
    category: 'Affaires et opportunités',
  },
  {
    label: 'Accès au réseau',
    value: 'network_access',
    iconName: 'amenity-network-access',
    category: 'Affaires et opportunités',
  },
  {
    label: 'Opportunités de clients',
    value: 'client_opportunities',
    iconName: 'amenity-client-opportunities',
    category: 'Affaires et opportunités',
  },
  {
    label: 'Stratégie marketing',
    value: 'marketing_strategy',
    iconName: 'amenity-marketing-strategy',
    category: 'Affaires et opportunités',
  },
  {
    label: 'Conseils sur les tarifs',
    value: 'pricing_advice',
    iconName: 'amenity-pricing-advice',
    category: 'Affaires et opportunités',
  },
].map(o => ({
  // Backwards compatibility with components that expect `key`
  key: o.value,
  ...o,
}));
